import { css } from '@mui/material';

const CommonStyle = css`
  text-align: center;
  letter-spacing: -0.02em;
  font-style: normal;
`;
export const H1 = css`
  ${CommonStyle}
  font-weight: 700;
  font-size: 56px;
  line-height: 84px;
`;
export const H2 = css`
  ${CommonStyle}
  font-weight: 700;
  font-size: 48px;
  line-height: 72px;
`;
export const H3 = css`
  ${CommonStyle}
  font-weight: 700;
  font-size: 40px;
  line-height: 60px;
`;
export const H4 = css`
  ${CommonStyle}
  font-weight: 700;
  font-size: 32px;
  line-height: 48px;
`;
export const H5 = css`
  ${CommonStyle}
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
`;
export const H5_light = css`
  ${CommonStyle}
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
`;
//B1 20/30
export const B1_Large_Regular = css`
  ${CommonStyle}
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
`;
export const B1_Large_Medium = css`
  ${CommonStyle}
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
`;
export const B1_Large_Semibold = css`
  ${CommonStyle}
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
`;
export const B1_Medium_Regular = css`
  ${CommonStyle}
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
`;
export const B1_Medium_Medium = css`
  ${CommonStyle}
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
`;
export const B1_Medium_Semibold = css`
  ${CommonStyle}
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
`;
export const B2_Large_Regular = css`
  ${CommonStyle}
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
`;
export const B2_Large_Medium = css`
  ${CommonStyle}
  font-weight: 500;
  font-size: 15px;
  line-height: 20px;
`;
export const B2_Large_Semibold = css`
  ${CommonStyle}
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
`;
export const B2_Medium_Regular = css`
  ${CommonStyle}
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
`;
export const B2_Medium_Medium = css`
  ${CommonStyle}
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
`;
export const B2_Medium_Semibold = css`
  ${CommonStyle}
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
`;
export const C1_Regular = css`
  ${CommonStyle}
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
`;
export const C1_Medium = css`
  ${CommonStyle}
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
`;
export const C1_Semibold = css`
  ${CommonStyle}
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;
`;
export const C2_Regular = css`
  ${CommonStyle}
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
`;
export const C2_Medium = css`
  ${CommonStyle}
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
`;
export const C2_Semibold = css`
  ${CommonStyle}
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
`;
export const C3_Regular = css`
  ${CommonStyle}
  font-weight: 400;
  font-size: 10px;
  line-height: 16px;
`;
export const C3_Medium = css`
  ${CommonStyle}
  font-weight: 500;
  font-size: 10px;
  line-height: 16px;
`;
export const C3_Semibold = css`
  ${CommonStyle}
  font-weight: 600;
  font-size: 10px;
  line-height: 16px;
`;
export const C4_Medium = css`
  ${CommonStyle}
  font-weight: 500;
  font-size: 10px;
  line-height: 14px;
`;
export const DeviceSizes = {
  extension: `(max-width: 600px)`,
};
